<template>
	<div :key="componentKey">
		<div class="loading-container" v-if="articleContentLoading">
			<loading-overlay></loading-overlay>
		</div>
		<transition name="fade" v-on:enter="checkIEBrowser">
			<div v-if="checkArticleData" class="container articles-container">
				<div class="article-content-container pb-0">
					<div class="container-submit-spinner" v-if="submitLoading">
						<loading-overlay></loading-overlay>
					</div>
					<div class="row justify-content-center">
						<div class="col-12 mb-3">
							<div class="row justify-content-between px-3">
								<div
									class="article-content-background col-lg-9 col-12 mt-5 d-flex flex-column justify-content-between pt-4 px-0"
								>
									<div class="article-inner-card">
										<div class="back-button-container pb-3">
											<a class="px-0" @click="redirectToDefaultBrowse">
												<font-awesome-icon :icon="['fas', 'arrow-left']" />
												<span class="pl-1">{{ platformTitle }}</span>
											</a>
										</div>
										<div class="title-header-text">
											<span
												>
												{{ articleContent.name }}
												<employee-hub-bookmark
													:title="articleContent.name"
											/></span>
										</div>

										<div
											:class="platformDynamicBar"
											class="d-flex flex-lg-row flex-column mt-2 px-2 py-1 mb-2"
										></div>
										<div v-if="formattedUpdatedAt" class="pb-3 updated-at-text">
											<i>Last updated: {{formattedUpdatedAt}}</i>
										</div>
										<div v-if="articleContent.faqs">
											<knowledge-faq-article-content class="content-container pt-3 pb-4"
												:article-header="articleContent.faqHeader"
												:faqs-data="articleContent.faqs"
												:article-footer="articleContent.faqFooter"/>
										</div>
										<div v-else>
											<div
												class="content-container pt-2"
												:class="platformDynamicClass"
												v-html="
													isCleanseHTML
														? $options.filters.consistentStylesKb(
																articleContent.content
														  )
														: articleContent.content
												"
											></div>
										</div>
									</div>
									<div class="justify-content-between">
										<div
											v-if="
												articleContent.displayAttachments &&
													articleContent.attachments &&
													articleContent.attachments.length > 0
											"
											class="px-lg-5 px-2 pb-3 attachment-container"
										>
											<div class="px-lg-4 px-3">
												<hr />
												<span class="attachment-title">Attachments</span>
												<div
													v-for="(attachment,
													index) in articleContent.attachments"
													:key="index"
												>
													<a target="_blank" :href="attachment.url">{{
														attachment.fileName
													}}</a>
												</div>
											</div>
										</div>

										<div
											class="rating-container d-flex align-items-lg-center justify-content-between px-3 py-3 flex-lg-row flex-column"
										>
											<div class="pb-lg-0 pb-3">
												<span>{{ articleContent.kbNumber }}</span>
												<span
													v-if="articleContent.rating > 0"
													class="mx-3 separator"
													>|</span
												>
												<span v-if="articleContent.rating > 0">
													<span
														class="rate-star"
														v-for="(star, key) in rateArr"
														:key="key"
													>
														<font-awesome-icon
															class="rating-solid-star"
															v-if="star <= Math.ceil(articleContent.rating)"
															:icon="['fas', 'star']"
														/>
														<font-awesome-icon
															v-if="star > Math.ceil(articleContent.rating)"
															:icon="['far', 'star']"
														/>
													</span>
												</span>
											</div>
											<div>
												<span class="d-flex align-items-center">
													<font-awesome-icon :icon="['far', 'eye']" />
													<span class="pl-2"
														>{{ articleContent.viewCount }} Views</span
													>
												</span>
											</div>
										</div>
									</div>
								</div>

								<div
									v-if="relatedArticles && relatedArticles.length"
									class="related-articles-container col-lg-3 col-12 mt-5 px-0 mx-0 pl-0"
								>
									<div class="related-articles-title pt-4 pb-2 px-3">
										<h6>Related articles</h6>
									</div>
									<div
										class="related-article"
										v-for="relatedArticle in relatedArticles"
										:key="relatedArticle.id"
									>
										<a
											:title="relatedArticle.name"
											:href="buildRelatedArticleUrl(relatedArticle)"
											>{{ relatedArticle.name }}</a
										>
									</div>
									<div
										v-if="showRelatedArticlesTitle"
										class="related-article pt-3"
									>
										<a
											class="view-all-articles"
											@click="redirectToDefaultBrowse"
											>{{ platformTitle }}</a
										>
									</div>
								</div>
							</div>
							<div class="row mt-4" v-if="showSuccessfulMessage">
								<div class="col-lg-9 feedback-message-container py-3">
									<h6>Thank you for your feedback!</h6>
								</div>
							</div>
							<div class="row footer-article-content" :class="articleComments && articleComments.length === 0 ? 'py-5' : 'py-4'">
								<div class="col-lg-9">
									<div>
										<span>Have feedback on this info? Please send us a comment!</span>
									</div>
									<div class="mt-3">
                      <froala v-if="isEditorReady" v-model="feedbackText" :config="froalaConfig" class="mb-4"></froala>
									</div>
									<div v-if="showFeedbackValidationError" class="row">
										<div class="text-danger">Please provide both a comment and a rating to proceed.</div>
									</div>
									<div
										class="row rate-container flex-lg-row justify-content-between" :class="articleComments && articleComments.length === 0 ? 'mb-5' : null"
									>
										<div
											class="col-md-12 d-flex flex-column flex-lg-row mb-lg-0"
										>
											<div class="h-100 align-items-center d-flex">
												<span class="pr-2">Rate this article:</span>
												<div class="d-flex">
													<button
														v-for="(rate, key) in rateArr"
														:key="key"
														@click="setArticleRate(rate)"
														@mouseover="setRateHover(rate)"
														@mouseleave="resetRateHover()"
														class="rate-button px-0 pr-1"
													>
														<font-awesome-icon
															v-if="rate > articleRate"
															:icon="['far', 'star']"
														/>
														<font-awesome-icon
															v-if="rate <= articleRate"
															class="rate-active-button"
															:icon="['fas', 'star']"
														/>
													</button>
												</div>
											</div>
											<button
												:disabled="disableSubmitButton"
												@click="submitArticleRate"
												class="submit-rating-button ml-lg-2 py-2"
											>
												SUBMIT
											</button>
										</div>
									</div>

								</div>
						</div>
							<knowledge-article-comments
								:article-comments="articleComments"
							/>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<div
			v-if="checkNoArticle"
			class="py-5 row no-article-container justify-content-center"
		>
			<div class="row" v-if="errorMessage">
				<div class="col-md-12 col-12">
					<div class="fade-in-out alert alert-error px-4">
						<div>{{ errorMessage }}</div>
					</div>
				</div>
			</div>
			<h4 v-else>Sorry, the selected article was not found.</h4>
		</div>
	</div>
</template>

<script>
import filter from "../../utils/filter";
import { mapGetters, mapActions, mapMutations } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay";
import moment from "moment";
import * as CONSTANTS from "@/store/constants";
import api from "@/api";
import Velocity from "velocity-animate";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar, faEye } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft, faReply } from "@fortawesome/free-solid-svg-icons";
import UserIcon from "@/components/UserIcon";
import VueScrollTo from "vue-scrollto";
import Vue from "vue";
import VueFroala from "vue-froala-wysiwyg";
import FroalaEditor from "froala-editor";
import FroalaMixin from '../../mixins/FroalaMixin';


import KnowledgeArticleComments from "@/components/knowledge-article/KnowledgeArticleComments";
import KnowledgeFaqArticleContent from "@/components/knowledge-article/KnowledgeFaqArticleContent";

Vue.use(VueScrollTo);

library.add({ faStar, faArrowLeft, faEye, faReply });
export default {
	name: "KnowledgeArticle",
	filters: filter,
	data() {
		return {
			content: "",
			componentKey: 0,
			feedbackText: "",
      toolbarButtons:["fullscreen",
        "bold",
        "italic",
        "underline",
        "strikeThrough",
        "clearFormatting",
        "formatOL",
        "formatUL",
        "outdent",
        "indent",
        "-",
        "insertLink",
        "insertImage",
        "specialCharacters",
        "clearFormatting",
        "help",
        "html",
        "undo",
        "redo"],
      froalaZIndex: 10,
			rateArr: [1, 2, 3, 4, 5],
			articleRate: 0,
			rating: 5,
			submitLoading: false,
			showSuccessfulMessage: false,
			articleContentLoading: false,
			starsSubmitted: false,
			hoverIsActive: false,
			checkErrorMessage: false,
			feedbackSubmissionAttempted: false
		};
	},
  mixins: [FroalaMixin],
	computed: {
		...mapGetters([
			"articleContent",
			"errorMessage",
			"country",
			"user",
			"userName",
			"currentCategory",
			"platformCategories",
			"authResponse",
			"articleComments",
			"platformCategory"
		]),
    froalaConfig() {
      //Modifying froala editor toolbar buttons specific to this component
      this.config.toolbarButtons = this.toolbarButtons
      this.config.zIndex = this.froalaZIndex
      return this.config
    },
		isITPlatform() {
			return this.$route.params.platformCategory === "IT";
		},
		routeParams() {
			return this.$route.params;
		},
		showRelatedArticlesTitle() {
			if (this.platformCategories && this.platformCategories.length > 0) {
				let filteredPlatformCategories = this.platformCategories.filter(
					(category) => {
						return category.alias == this.routeParams.platformCategory;
					}
				);
				if (
					filteredPlatformCategories &&
					filteredPlatformCategories.length > 0
				) {
					return !filteredPlatformCategories[0].hideViewAllRelatedArticlesLink;
				}
			}
			return true;
		},
		platformTitle() {
			let categoryTitle = this.routeParams.platformCategory;
			if (this.platformCategories && this.platformCategories.length > 0) {
				this.platformCategories.forEach((category) => {
					if (category.alias == this.routeParams.platformCategory) {
						categoryTitle = category.name;
					}
				});
			}

			if (this.platformConfig && this.platformConfig.showAllGuidesLink) {
				return (
					"View " +
					categoryTitle +
					" " +
					this.articleContent.kbCategoryName +
					" guide"
				);
			}
			if (
				this.articleContent.kbCategoryName &&
				this.articleContent.kbCategoryName.startsWith(categoryTitle)
			) {
				return "View all " + this.articleContent.kbCategoryName + " articles";
			} else {
				return (
					"View all " +
					categoryTitle +
					" " +
					this.articleContent.kbCategoryName +
					" articles"
				);
			}
		},
		updatedDifference() {
			return moment(this.articleContent.updatedAt).fromNow();
		},
		platformDynamicClass() {
			return `articles-content-${this.routeParams.platformCategory.toLowerCase()}-container`;
		},
		isCleanseHTML() {
			return this.routeParams.platformCategory == "IT";
		},
		checkActive() {
			return (rate) => (rate <= this.articleRate ? "rate-active-button" : "");
		},
		checkNoArticle() {
			return (
				(!this.articleContentLoading &&
				!this.platformCategories ) ||
				!(this.articleContent && this.articleContent.id)
			);
		},
		checkArticleData() {
			return (
				!this.articleContentLoading &&
				this.articleContent &&
				this.articleContent.id
			);
		},

		platformDynamicBar() {
			return `info-bar-${this.routeParams.platformCategory.toLowerCase()}`;
		},
		relatedArticles() {
			const removingCurrentArticle =
				this.articleContent.relatedtArticles &&
				this.articleContent.relatedtArticles.length
					? this.articleContent.relatedtArticles.filter(
							(relatedArticled) =>
								relatedArticled.id !== this.routeParams.articleId
					  )
					: [];
			let formattedCurrentArticles = removingCurrentArticle.slice(0, 5);
			return formattedCurrentArticles.sort((c1, c2) =>
				c1.name.localeCompare(c2.name)
			);
		},
		disableSubmitButton() {
			return !this.starsSubmitted && this.feedbackText.trim().length === 0;
		},
		checkError() {
			return this.errorMessage && this.errorMessage.indexOf("not found") !== -1;
		},
		platformConfig() {
			let filteredPlatformCategory;
			if (this.platformCategories && this.platformCategories.length > 0) {
				let filteredPlatformCategories = this.platformCategories.filter(
					(category) => {
						return category.alias == this.routeParams.platformCategory;
					}
				);
				filteredPlatformCategory = filteredPlatformCategories[0];
			}
			return filteredPlatformCategory;
		},
		isFeedbackInputValid() {
			return this.articleRate > 0 && this.feedbackText.trim().length;
		},
		showFeedbackValidationError() {
		  let feedbackValid = this.starsSubmitted && this.isFeedbackInputValid;
		  return !feedbackValid && this.feedbackSubmissionAttempted;
		},
		formattedUpdatedAt() {
			let showArticleUpdatedAt = this.getShowUpdatedAt();
			return showArticleUpdatedAt ? this.getFormattedUpdatedAt() : null
		},
	},
	watch: {
		"user.userName": function() {
			this.getArticleContent();
			this.componentKey++;
		},
		country: function() {
			this.getArticleContent();
			this.componentKey++;
		},
		"$route.params": {
			handler(oldValue, newValue) {
				if (!newValue || oldValue.articleId !== newValue.articleId) {
					this.getArticleContent();
				}
			},
			immediate: true,
		},
		errorMessage: function() {
			if (this.errorMessage && this.errorMessage.indexOf("not found") > -1) {
				this.$router.push({ name: "page-not-found" });
			}
		},
	},
	components: {
		LoadingOverlay,
		UserIcon,
		KnowledgeArticleComments,
		KnowledgeFaqArticleContent
	},
	async created() {
		document.title = `${this.$route.params.platformCategory} Knowledge article - Autodesk One`;
	},
	methods: {
		...mapActions([
			"fetchArticleContent",
			"fetchUser",
			"saveArticleRating",
			"saveArticleComments",
			"saveArticleFeedback",
			"fetchPlatformCategories",
			"fetchArticleComments",
			"fetchWolkenArticleComments"
		]),
		...mapMutations(["setErrorMessage"]),
		async setWolkenArticleComments() {
			const useWolken = this.isUseWolken();
			if (useWolken && this.articleContent.feedbackList && this.articleContent.feedbackList.length > 0) {
				const feedbackList = await Promise.all(this.articleContent.feedbackList.map(async (feedback) => {
					const user = await api.getUserInfoByEmail(feedback.user);
					return {
						...feedback,
						sys_id: feedback.id,
						sys_created_on: feedback.createdAt,
						parent_comment: null,
						'user.user_name': user.data && user.data.length > 0 ? user.data[0].userName : feedback.user
					};
				}));
				console.log(feedbackList)
				this.$store.commit("setArticleComments", feedbackList);
			}
		},
		async getArticleContent() {
			try {
				this.articleContentLoading = true;
				await this.fetchPlatformCategories();
				
				let promises = [];
				promises.push(this.getContent());

				const isLegacyArticleId = /[0-9a-f]{32}/.test(this.routeParams.articleId);
				console.log('isLegacyArticleId:', isLegacyArticleId);
				// If the article ID is not a legacy ID, fetch the comments right away 
				// else wait for the article content to be fetched
				if (!isLegacyArticleId) {
					let commentsPromise = this.fetchWolkenArticleComments({
						articleId: this.routeParams.articleId
					}).catch(error => {
						console.error('Error fetching Wolken article comments:', error);
						return [];
					});
					promises.push(commentsPromise);
					await Promise.all(promises);
					this.articleContentLoading = false;
				}
				else {
					await Promise.all(promises);
					this.articleContentLoading = false;
					await this.fetchWolkenArticleComments({
						articleId: this.articleContent.id
					}).catch(error => {
						console.error('Error fetching Wolken article comments:', error);
						return [];
					});
				}

				if (this.articleContent && this.articleContent.name) {
					document.title = `${this.articleContent.name} - ${this.$route.params.platformCategory} - Autodesk One`;
				}
				//Scroll to hash if hash is provided in the URL.
				//Need to implement this custom logic as content is loaded via API call.
				let that = this;
				Vue.nextTick(function() {
					if (that.$route.hash) {
						//Try with Jquery # i.e. id and then with name attribute
						let hash = that.$route.hash;
						that.$scrollTo(hash, 300, {
							easing: "linear",
						});

						//Some knowledge articles have anchor by name instead of hash-id
						//This patch applies a fix such that it works for all KB articles
						let attrName = hash.replace("#", "");
						that.$scrollTo(`a[name=${attrName}]`, 300, {
							easing: "linear",
						});
					}
				});
			} catch (e) {
				if (this.checkError) {
					this.checkErrorMessage = true;
					this.setErrorMessage(CONSTANTS.ERROR_MESSAGE);
				}
			} finally {
				this.articleContentLoading = false;
			}
		},
		checkIEBrowser(el, done) {
			//Check IE Browser to display transition
			if (!!window.MSInputMethodContext && !!document.documentMode) {
				done();
			}
		},
		async getContentAfterSubmit() {
			try {
				let bannerVisibleTime = 5000;
				await this.getContent();
				this.articleContentLoading = false;
				this.submitLoading = false;
				this.showSuccessfulMessage = true;
				this.starsSubmitted = false;
				this.articleRate = 0;
				this.feedbackText = "";
				this.feedbackSubmissionAttempted = false;
				setTimeout(() => {
					this.showSuccessfulMessage = false;
				}, bannerVisibleTime);
			} catch (e) {
				if (this.checkError) {
					this.checkErrorMessage = true;
				}
				this.articleContentLoading = false;
			}
		},
		getContent() {
			return this.fetchArticleContent({
				platformCategory: this.routeParams.platformCategory,
				knowledgeBrowseId: this.routeParams.articleId,
			})
		},

		setArticleRate(value) {
			let articleValue = value;
			let currentStar = 1;
			if (this.articleRate === value && !this.hoverIsActive) {
				articleValue = value - currentStar;
			}

			this.hoverIsActive = false;
			this.starsSubmitted = true;

			if (articleValue === 0) {
				this.starsSubmitted = false;
			}
			this.articleRate = articleValue;
		},
		setRateHover(value) {
			let articleValue = value;
			if (!this.starsSubmitted) {
				this.articleRate = articleValue;
				this.hoverIsActive = true;
			}
		},
		resetRateHover() {
			if (!this.starsSubmitted) {
				this.articleRate = 0;
			}
		},
		submitArticleRate() {
			if (!this.isFeedbackInputValid) {
				this.feedbackSubmissionAttempted = true;
				return;
			}

			this.submitLoading = true;
			let kbFeedbackRequestBody = {
				"article": this.routeParams.articleId,
				"comments": this.feedbackText,
				"rating": this.articleRate
			}

			this.saveArticleFeedback({
        platformCategory: this.routeParams.platformCategory,
				requestBody: kbFeedbackRequestBody
			})
			.catch((e) => {
				if (this.checkError) {
					this.checkErrorMessage = true;
				}
			}).finally(() => {
				this.submitLoading = false;
				this.$hhMixpanel.trackEvent(
					`${this.platformCategory} Knowledge Browse - ${this.articleContent.name} feedback submitted`
				);
				this.getContentAfterSubmit();
			})
		},
		closeCurrentArticle() {
			if (this.currentCategory) {
				this.$router.push({
					name: "knowledge-articles-by-id",
					params: { id: this.currentCategory },
				});
			} else {
				this.redirectToDefaultBrowse();
			}
		},

		redirectToDefaultBrowse() {
			let platformConfig = this.platformConfig;
			if (platformConfig && platformConfig.viewAllUrlFormat) {
				let baseUrl = EMPLOYEE_HUB_URL + platformConfig.viewAllUrlFormat;
				window.location.href =
					this.articleContent && this.articleContent.kbCategory
						? baseUrl + this.articleContent.kbCategory
						: baseUrl;
			} else {
				let path = `/${this.routeParams.platformCategory}/article-categories`;
				path =
					this.articleContent && this.articleContent.kbCategory
						? path + "/" + this.articleContent.kbCategory
						: path;
				this.$router.push(path);
			}
		},
		buildRelatedArticleUrl(article) {
			return article.url
				? article.url
				: `/${this.routeParams.platformCategory}/articles/${article.id}`;
		},
		getShowUpdatedAt() {
			let currentCategory = this.$route.params.platformCategory;
			let category = this.platformCategories.find(category => category.alias === currentCategory)
			return category && category.showArticleUpdatedAt && category.showArticleUpdatedAt === true;
		},
		getFormattedUpdatedAt() {
			if (this.articleContent && this.articleContent.contentUpdatedAt) {
				return moment(this.articleContent.contentUpdatedAt).format("LL")
			}
			else if (this.articleContent && this.articleContent.updatedAt) {
				return moment(this.articleContent.updatedAt).format("LL")
			}
			else {
				return null
			}
		},
		isUseWolken() {
			let wolkenUsePlatformCategory = this.platformCategories.find(category => category.alias === this.routeParams.platformCategory);
			return wolkenUsePlatformCategory && wolkenUsePlatformCategory.useWolken;
		}
	},
};
</script>

<style scoped>

.alert {
	border-radius: 0;
}
.loading-container {
	min-height: 95vh;
}
.title-header-text span {
	color: #000000;
	font-size: 38px;
	font-family: artifaktElementBold !important;
}
.overview-text span {
	font-size: 16px;
	font-weight: bold;
}

.info-header-bar {
	background: linear-gradient(90deg, #0696d7, #32bcad 50.93%, #87bc40);
	background: -webkit-gradient(
		linear,
		left top,
		right top,
		from(#0696d7),
		color-stop(50.93%, #32bcad),
		to(#87bc40)
	);
	background: linear-gradient(90deg, #0696d7, #32bcad 50.93%, #87bc40);
}

.info-header-bar span {
	font-size: 11pt;
	font-weight: bold;
	color: #fff;
}


.rating-container span svg {
	color: #000000;
}

.rating-container span .rating-solid-star {
	color: var(--secondary-color);
}

.footer-article-content {
	background-color: white;
}

.footer-article-content span,
.footer-article-content a {
	font-size: 14px;
	color: #000000;
	font-weight: bold;
}
.footer-article-content a {
	background: transparent;
	border: none;
	cursor: pointer;
	text-decoration: none;
}
.footer-article-content textarea {
	border-radius: 2px;
	resize: none;
	border: 1px solid #b0b9c3;
	font-size: 12px;
	padding: 10px;
	width: 100%;
}
.footer-article-content textarea:focus-visible {
	    outline: var(--secondary-color) auto 1px !important;
}

.related-articles-container {
	max-height: 10vh;
	padding-left: 35px !important;
}

.related-articles-title h6 {
	margin: 0;
}

.related-articles-title {
	background: #f6f6f6;
	padding-bottom: 11pt;
}

@media (max-width: 998px) {
	.related-articles-container {
		max-height: 40vh;
		margin-bottom: 20px;
		padding-left: 0px !important;
	}
}

.related-articles-container h6 {
	font-size: 26px;
	color: #000000;
	font-family: artifaktElementBold;
}
.related-articles-container a {
	font-size: 16px;
	color: #0696d7;
	font-weight: bold;
	text-decoration: none;
}
.related-articles-container a:hover {
	color: var(--secondary-color-hover);
}

.related-articles-container .view-all-articles {
	font-style: italic;
	font-size: 15px;
}

.related-article {
	background: #f6f6f6;
	padding-left: 16px;
	cursor: pointer;
	padding-right: 16px;
	color: #0696d7;
	font-weight: 700;
	padding-bottom: 10px;
	font-size: 11pt;
}

.related-article a {
	color: #666666 !important;
	text-decoration: underline;
}

.related-article:last-child {
	padding-bottom: 1.5rem !important;
}


.fade-enter-active,
.fade-leave-active {
	transition-duration: 1s;
	transition-property: opacity;
	transition-timing-function: ease;
	-webkit-animation-name: none !important;
}
.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.rate-container svg {
	font-size: 16px !important;
}

.rate-button {
	background: none;
	border: none;
	outline: none;
	height: 18px;
	display: flex;
}

.rate-button .fa-star {
	color: #000000;
}
.rate-button .fa-star:hover {
	color: var(--secondary-color);
}
.comment-text {
	display: inline-block;
	flex-basis: auto;
	flex-shrink: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	padding-left: 40px;
	font-size: 16px;
	color: #000000;
	word-break: break-word;
}

.comment-text >>> a {
	color: var(--secondary-color) !important;
}

.comment-text:hover >>> a {
	color: var(--secondary-color-hover) !important;
}

.rate-button .rate-active-button {
	color: var(--secondary-color);
}

.rate-button .rate-active-button:hover {
	color: var(--secondary-color-hover);
}

.attachment-title {
	color: #717171;
	font-size: 11pt;
	font-weight: bold;
}

.attachment-container a {
	color: #0696d7;
	font-size: 11pt;
}
.attachment-container a:hover {
	color: var(--secondary-color-hover);
}
.submit-rating-button {
	background-color: #fff;
	width: 200px;
	border: 1.2px solid var(--secondary-color);
	color: var(--secondary-color);
	outline: none;
	font-size: 11pt;
	border-radius: 18px;
}

@media (max-width: 767px) {
	.submit-rating-button {
		width: 100%;
		margin-top: 0.5rem !important;
	}
}

.submit-rating-button:disabled,
.submit-rating-button:disabled:hover {
	background: #f0f0f0;
	color: #71737e;
	border: 1.2px solid #b5b5b5;
	border-radius: 18px;
}

.submit-rating-button:hover {
	background: var(--secondary-color);
	color: #fff;
}

.container-submit-spinner {
	position: fixed;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.52);
	z-index: 50;
}

.attachments-container li {
	text-decoration: none;
	list-style: none;
}
.attachments-container li a {
	color: #0696d7;
}

.back-button-container a {
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;
	color: #000000 !important;
}


.back-button-container svg {
	font-size: 14px;
}

.back-button-container span {
	font-size: 16px;
	color: #000000;
	font-weight: bold;
}

.back-button-container span:hover {
	color: #000000 !important;
}

.feedback-message-container {
	background: #87bc40;
}

.feedback-message-container h6 {
	color: #fff;
	margin: 0;
}

.no-article-container {
	min-height: 55vh;
	background: #fff;
}

.article-inner-card {
	padding: 0px 30px 0px 30px;
}

.updated-at-text {
   font-size: 13px;
   color: #000000;
   font-weight: bold;
}

</style>

<style>


body {
	font-size: 16px;
	color: #000000 !important;
}
</style>

<style lang="css" src="../../../static/EmployeeHubKnowledgeStyles.css"></style>



// WEBPACK FOOTER //
// src/components/knowledge-article/KnowledgeArticle.vue